import React from 'react';
const TPAComponentsContext = React.createContext({});
/**
 * Drop-in replacement for `TPAComponentsProvider` from `wix-ui-tpa/cssVars`.
 *
 * Kept so the single call site (fallback-state.tsx) is unchanged. Note the WUT original
 * had a known context-divergence bug — the scoped and unscoped packages created two
 * separate React contexts, so `mobile` / `rtl` silently never arrived (`#wix-ui-tpa`,
 * Feb 2026). Nothing in this package reads the context today; the local primitives take
 * mobile/rtl as explicit props instead. If that stays true, this provider and its single
 * call site can simply be deleted.
 */
export const TPAComponentsProvider = ({ value, children, }) => React.createElement(TPAComponentsContext.Provider, { value: value }, children);
export const useTPAComponentsConfig = () => React.useContext(TPAComponentsContext);
//# sourceMappingURL=TPAComponentsProvider.js.map